module.exports = __webpack_public_path__ + "static/gsa-1e5ad283c41473d30c77da2341369e02.jpg";